<template>
  <li class="side-menu-list__item icon-admin-white" :class="icon" v-if="adminUrl !== ''">
    <a target="_blank" :href="adminUrl" class="side-menu-list__icon"></a>
  </li>
</template>

<script>
  export default {
    vuex: {
      getters: {
        scroll: state => state.scrolled,
        adminUrl: state => state.menu.AdminUrl
      }
    },
    computed: {
      icon () {
        var icon = (this.$route.path === "/" && !this.scroll) ? "icon-admin-white" : "icon-admin";
        icon += (this.sidebarActive && !this.active) ? " icon--disabled" : "";
        return icon;
      }
    }
  };
</script>
<style lang="scss">
  .icon-admin{
    background: url(../../../assets/img/gear-icon.png) no-repeat top right;
  }

  .icon-admin-white{
    background: url(../../../assets/img/gear-icon-white.png) no-repeat top right;
  }
</style>


// WEBPACK FOOTER //
// SidebarAdministration.vue?5ea3662c